import {
  FIELD_BLOCK_HEIGHT_WITH_LABEL,
  FIELD_HEIGHT,
  FIELD_LABEL_HEIGHT
} from "../../../../core/et3-input/et3-text-input/text-input-constants";

export const SEARCH_FORM_ROW_GAP = 16;
export const SEARCH_FORM_FIELD_GAP = 20;
export const SEARCH_FORM_INPUT_WIDTH = 420;
export const SEARCH_FORM_BUTTON_TOP_OFFSET =
  (FIELD_BLOCK_HEIGHT_WITH_LABEL - FIELD_LABEL_HEIGHT - FIELD_HEIGHT) / 2 +
  FIELD_LABEL_HEIGHT;
